export const Experiments = {
  cookie_banner_optin_rate: 'cookie_banner_optin_rate',
  cookie_banner_optin_rate_jing: 'cookie_banner_optin_rate_jing',
};

export enum Variants {
  N = '',
  A = 'A',
  B = 'B',
  C = 'C',
}
